// One-time migration script to add fullName to existing users
// Run this from browser console on your app

import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function migrateUserNames() {
  console.log("Starting user name migration...");
  
  try {
    const usersRef = collection(db, "users");
    const usersSnap = await getDocs(usersRef);
    
    let updated = 0;
    let skipped = 0;
    
    for (const userDoc of usersSnap.docs) {
      const userData = userDoc.data();
      
      // Skip if fullName already exists
      if (userData.fullName) {
        skipped++;
        continue;
      }
      
      // Generate fullName from email
      const fullName = userData.email?.split('@')[0] || "User";
      
      await updateDoc(doc(db, "users", userDoc.id), {
        fullName: fullName
      });
      
      updated++;
      console.log(`Updated ${userData.email} with fullName: ${fullName}`);
    }
    
    console.log(`✅ Migration complete! Updated: ${updated}, Skipped: ${skipped}`);
    alert(`Migration complete! Updated ${updated} users.`);
    
  } catch (error) {
    console.error("Migration failed:", error);
    alert("Migration failed: " + error.message);
  }
}

// To run this migration:
// 1. Open your app in the browser
// 2. Open browser console (F12)
// 3. Type: window.migrateUserNames()
// 4. Press Enter

if (typeof window !== 'undefined') {
  window.migrateUserNames = migrateUserNames;
}
